export function isLocalHostname(hostname: string): boolean {
  const normalized = hostname.trim().toLowerCase()

  return normalized === 'localhost' || normalized === '127.0.0.1' || normalized === '[::1]'
}
